(function ($) {
    // see: https://stackoverflow.com/questions/36098913/convert-seconds-to-days-hours-minutes-and-seconds/36099084
    function formatSeconds(secs) {
        function pad(n) {
            return (n < 10 ? "0" + n : n);
        }

        secs = Number(secs);

        const d = Math.floor(secs / (3600*24));
        const h = Math.floor(secs % (3600*24) / 3600);
        const m = Math.floor(secs % 3600 / 60);
        const s = Math.floor(secs % 60);

        let result = [];

        (d > 0) && result.push(d + 'g');
        (h > 0 || d > 0) && result.push(pad(h) + 'o');
        (m > 0 || h > 0 || d > 0) && result.push(pad(m) + 'm');
        (s > 0 ) && result.push(
            (!result.length ? (s + (s == 1 ? ' secondo' : ' secondi')) : (pad(s) + 's'))
        );

        if (!result.length) {
            result.push('Tempo scaduto!');
        }

        return result.join(' ');
    }

    const updateProgressBar = (element, percentage) => {
        $(element)
            .attr('aria-valuenow', percentage)
            .css('width', `${percentage}%`)
    }

    $.fn.redirector = function (options) {
        return this.each(function () {
            const $this = $(this)
            const redirectUrl = $this.data('url')
            const progressBar = $this.data('progress')
            const noRedirect = $this.data('no-redirect');
            let seconds = parseInt($this.data('time') || $this.text(), 10)
            const startSeconds = seconds
            const startProgress = progressBar ? Number.parseInt($(progressBar).attr('aria-valuenow'), 10) : 0
            const tickProgress = (100 - startProgress) / seconds

            if ($this.hasClass('configured')) {
                return;
            }

            $this.addClass('configured')
            $this.css('white-space', 'nowrap')
            const countdown = function () {
                seconds--
                if (seconds < 0) {
                    console.log('countdown finished', seconds, redirectUrl)
                    progressBar && updateProgressBar(progressBar, 100)
                    clearInterval(countdown)
                    if (redirectUrl == '.') {
                        location.reload(true)
                    } else if (redirectUrl && !noRedirect) {
                        location.replace(redirectUrl)
                    } else {
                        $.ajax({
                            url: redirectUrl,
                            method: 'POST',
                            xhrFields: {
                                withCredentials: true
                            }
                        }).done(function (response, status, xhr) {
                            console.log(response)
                        }).fail(function (error) {
                        })
                    }
                } else {
                    // console.log('countdown tick', seconds)
                    $this.text(formatSeconds(seconds))
                    progressBar && updateProgressBar(progressBar, Math.ceil( startProgress + (tickProgress * (startSeconds - seconds)) ))
                    // console.log(progressBar, startProgress, tickProgress, seconds, Math.ceil( startProgress + (tickProgress * (startSeconds - seconds)) ) )
                    setTimeout(countdown, 1000)
                }
            }

            countdown()
            console.log('start countdown until ', seconds)

            return this
        });
    }

    $('[data-toggle="redirector"]').redirector()

})(jQuery)
